import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { busca_notas_no_prazo, busca_prazo_avaliacao } from "../../services/api";

const Percent_lanc_Unidade_Serie_Prazo = (props) => {

    let avaliacao = props.av;
    let unidade = props.un;

    // const [avaliacao, setAvaliacao] = useState(avainico || "AS2");
    const [data2, setData2] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [prazos, setPrazos] = useState([]);
    const [tabelafinal, setTabelaFinal] = useState([]);

    const avaliacaoOptions = [
        "AS1", "AQ1", "AP1", "AV1",
        "AS2", "AQ2", "AP2", "AV2",
        "AS3", "AQ3", "AP3", "AV3",
        "AS4", "AQ4", "AP4", "AV4",
    ];

    const unidades = ["", "Bento Ribeiro", "Madureira", "Santa Cruz", "Cascadura", "Taquara", "Nilopolis", "", "", "Seropédica", "Barra da Tijuca", "Campo Grande", "Centro de Excelência", "Mangueira", "Maricá", "Ilha do Governador", "Freguesia", "Recreio dos Bandeirantes"];

    const convertSegmento = (seg) => {
        switch (seg) {
            case "0-1": return "Mat 1";
            case "0-2": return "Mat 2";
            case "0-3": return "Pré 1";
            case "0-4": return "Pré 2";
            case "1-1": return "1º Fund I";
            case "1-2": return "2º Fund I";
            case "1-3": return "3º Fund I";
            case "1-4": return "4º Fund I";
            case "1-5": return "5º Fund I";
            case "1-6": return "6º Fund II";
            case "1-7": return "7º Fund II";
            case "1-8": return "8º Fund II";
            case "1-9": return "9º Fund II";
            case "2-1": return "1ª Médio";
            case "2-2": return "2ª Médio";
            case "2-3": return "3ª Médio";
            default: return seg;
        }
    };

    const fetchData = async () => {
        try {
            const response = await busca_notas_no_prazo(avaliacao);
            setData2(response || []);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [avaliacao]);

    useEffect(() => {
        if (Array.isArray(data2) && data2.length > 0) {
            const organizedData = {};
            const seriesSet = new Set();

            console.log("Data2", data2);

            data2.filter(item => item.unidade === unidade).forEach(item => {

                let percentprazo = (parseFloat(item.notas_no_prazo) * 100) / parseFloat(item.notas_esperadas);

                if (!organizedData[unidades[parseInt(item.unidade)]]) {
                    organizedData[unidades[parseInt(item.unidade)]] = {};
                }

                organizedData[unidades[parseInt(item.unidade)]][convertSegmento(item.serie)] = parseFloat(percentprazo.toFixed(2));

                // if (parseFloat(item.perc_notas_no_prazo) < 100) {
                //     organizedData[unidades[parseInt(item.unidade)]][convertSegmento(item.serie)] = parseFloat(item.perc_notas_no_prazo);
                // } else {
                //     organizedData[unidades[parseInt(item.unidade)]][convertSegmento(item.serie)] = 100;
                // }
                //organizedData[unidades[parseInt(item.unidade)]][convertSegmento(item.serie)] = parseFloat(item.perc);
                seriesSet.add(convertSegmento(item.serie));
            });


            const seriesArray = Array.from(seriesSet);

            const table = [["Unidade", ...seriesArray]];

            Object.keys(organizedData).forEach(unidade => {
                const row = [unidade];
                seriesArray.forEach(serie => {
                    row.push(organizedData[unidade][serie] || "-");
                });
                table.push(row);
            });

            setTableData(table);
        }
    }, [data2]);

    // useEffect(() => {
    //     if (Array.isArray(prazos) && prazos.length > 0 && tableData.length > 0) {
    //         const prazoMap = {};
    //         prazos.forEach(item => {
    //             prazoMap[convertSegmento(item.serie)] = item.dtf;
    //         });

    //         const prazosRow = ["Prazos"];
    //         tableData[0].slice(1).forEach(serie => {
    //             prazosRow.push(prazoMap[serie] || "-");
    //         });

    //         setTabelaFinal([tableData[0], prazosRow, ...tableData.slice(1)]);
    //     }
    // }, [prazos, tableData]);

    // const handleAvaliacaoChange = (event) => {
    //     setAvaliacao(event.target.value);
    // };

    const formatDate = (date) => {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
    };
    let tableDataOrdenado = [];

    if (tableData.length > 0) {

        // Separa o cabeçalho
        let cabecalho = tableData[0];

        // Pega o resto e ordena
        let restoOrdenado = tableData.slice(1).sort();

        // Junta novamente
        tableDataOrdenado = [cabecalho, ...restoOrdenado];
    }


    if (tableDataOrdenado.length > 0) {

        return (
            <div className="Percent" style={{ border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", borderRadius: "8px" }}>
                <label>
                    <h5>Porcentagem de notas dentro do Prazo - {avaliacao} </h5>
                    {/* Avaliação:
                <select value={avaliacao} onChange={handleAvaliacaoChange}>
                    {avaliacaoOptions.map(option => (
                        <option key={option} value={option}>{option}</option>
                    ))}
                </select> */}
                </label>

                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            {tableDataOrdenado[0]?.map((header, index) => (
                                <th key={index}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableDataOrdenado.slice(1).map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        style={{
                                            backgroundColor: typeof cell === "number" && cell >= 92
                                                ? "lightgreen"
                                                : typeof cell === "number" && cell >= 75
                                                    ? "yellow"
                                                    : typeof cell === "number" && cell >= 50
                                                        ? "orange"
                                                        : typeof cell === "number" && cell >= 30
                                                            ? "red"
                                                            : typeof cell === "number" && cell >= 15
                                                                ? "darkred"
                                                                : typeof cell === "number"
                                                                    ? "black"
                                                                    : "white",
                                            color: typeof cell === "number" && cell >= 75
                                                ? "black"
                                                : typeof cell === "number"
                                                    ? "white"
                                                    : "inherit",
                                        }}
                                    >
                                        {cell && /^\d{4}-\d{2}-\d{2}$/.test(cell) ? formatDate(cell) : cell} {typeof cell === "number" ? ' %' : ''}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };
};

export default Percent_lanc_Unidade_Serie_Prazo;
